<template>
  <div class="list-container">
    <div class="row">
      <div class="col-xs-6 col-sm-4 col-md-3" v-for="({ nickname, title, mico_id, cover_fid: cover, viewer_num }, index) of rooms" :key="index">
        <div class="row">
          <div class="tile-content">
            <a :href="'/live/' + mico_id" class="cover-box">
              <img class="cover" :src="'//thumbnail-middle.micoworld.net/' + cover" :data-cover="cover" onerror="this.onerror=null;this.src='//image.micoworld.net/' + this.getAttribute('data-cover')" alt="">
              <p class="title">{{ title }}</p>

              <div class="shadow hidden-xs">
                <div class="play-icon"></div>
              </div>
            </a>
            <div class="extra">
              <div class="nickname">{{ nickname }}</div>
              <div class="count">
                <img src="~@public/assets/web/viewer.png" alt="">
                <span>{{ viewer_num }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        rooms: window._rooms,
        loading: false
      }
    },
    methods: {
      list() {
        if (this.next && !this.loading) {
          this.loading = true
          $.get('/hot/list', {
            page: this.page++
          }, ({ rooms, next }) => {
            this.rooms.push(...rooms)
            this.next = next
            this.$nextTick(() => {
              this.loading = false
            })
          })
        }
      }
    }
  }
</script>
<style lang="less" scoped>
@import "../css/list.less";
</style>
